// extracted by mini-css-extract-plugin
module.exports = {"mountWrapper":"mountWrapper--GYu6O","embedContainer":"embedContainer--TNa8k","loadingOverlay":"loadingOverlay--84ccU"};